// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import dataTables from '@src/views/tables/data-tables/store'
import appCustomerSlice from '@src/views/apps/customers/store'
import appClustersSlice from '../views/settings/cluster/store'
import appUsersSlice from '../views/settings/users/store'
import department from '@src/views/settings/department/store'
import designation from '@src/views/settings/designation/store'
import client from '@src/views/settings/client/store'
import api from '@src/views/settings/api_doc/store'
import company from '@src/views/settings/company/store'
import appCommon from '../common/store'
import employee from '@src/views/employees/all_employees/store'
import roleManagement from '@src/views/settings/role_permission/store'
import modules from '@src/views/settings/modules/store'
import leaveSettings from '@src/views/settings/leave_settings/store'
import leaves from '@src/views/employees/leave_employee/store'
import project from '@src/views/projects/all_projects/store'
import leavesAdmin from '@src/views/employees/leave_admin/store'
import country from '@src/common/store/country'
import state from '@src/common/store/state'
import city from '@src/common/store/city'
import task from '@src/views/projects/tasks/store'
import holiday from '@src/views/employees/holidays/store'
import accountExpense from '@src/views/settings/account_expense/store'
import taxes from '@src/views/accounts/taxes/store'
import expenses from '@src/views/accounts/expenses/store'
import taskBoard from '@src/views/projects/task_board/store'
import attendance from '@src/views/employees/attendance_employee/store'
import attendanceAdmin from '@src/views/employees/attendance_admin/store'
import timeSheet from '@src/views/employees/timesheet/store'
import event from '@src/views/administration/events/store'
import employeeSalary from '@src/views/accounts/employee_salary/store'
import invoices from '@src/views/accounts/invoices/store'
import estimate from '@src/views/accounts/estimate/store'
import asset from '@src/views/administration/assets/store'
import getDashboard from '@src/views/dashboard/store'
import userDocument from '@src/views/settings/employee_document/store'
import activities from '@src/views/administration/activities/store'
import report from '@src/views/reports/store'
import employeeSalarySheet from '@src/views/accounts/employee_salary_sheet/store'

const rootReducer = {
  auth,
  navbar,
  layout,
  dataTables,
  appCustomerSlice,
  appClustersSlice,
  appUsersSlice,
  department,
  designation,
  api,
  client,
  company,
  employee,
  roleManagement,
  modules,
  leaveSettings,
  leavesAdmin,
  leaves,
  project,
  country,
  state,
  city,
  task,
  holiday,
  accountExpense,
  taxes,
  expenses,
  attendance,
  attendanceAdmin,
  timeSheet,
  event,
  employeeSalary,
  invoices,
  estimate,
  taskBoard,
  appCommon,
  asset,
  getDashboard,
  userDocument,
  activities,
  report,
  employeeSalarySheet
}

export default rootReducer
